import * as React from 'react';
import clsx from 'clsx';

import {react2panel} from 'common/util/react2panel';
import {SvgIconReact, SvgIconType} from 'common/components/svg-icon';
import {withStyles} from 'common/util/react';

import css from './index.module.styl?inline';
import styles from './index.module.styl';

type Props = React.ComponentProps<`div`> & {
  disabled?: boolean;
  focused?: boolean;
  icon?: SvgIconType;
  selected?: boolean;
  theme?: `lite`;
  children?: React.ReactNode;
  buttonStyle?: React.CSSProperties;
};

function RadioButton(props: Props) {
  const {disabled, focused, icon, selected, theme, children, buttonStyle, className, ...rest} = props;

  return (
    <div
      className={clsx(className, styles.wrapper, {
        [styles.selected]: selected,
        [styles.disabled]: disabled,
        [styles.focused]: focused,
        [styles.themeLite]: theme === `lite`,
      })}
      {...rest}
    >
      <div className={styles.button} style={buttonStyle}>
        <div className={styles.animationLayer} />
        <div className={styles.dot} />
      </div>
      {!!icon && (
        <div className={styles.content}>
          <SvgIconReact icon={icon} />
        </div>
      )}
      {children}
    </div>
  );
}

export const RadioButtonReact = withStyles(RadioButton, css);
export const RadioButtonEl = react2panel(`mp-radio-button`, RadioButtonReact);
